// extracted by mini-css-extract-plugin
export default {"wrapper":"uo-z","response":"vo-z","error":"wo-z","disabled":"xo-z","buttons":"yo-z","feedbackQuestionSection":"zo-z","yesNoWrapper":"Ao-z"};